import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'

type Props = {
  attachments: string[]
  isUserMessage?: boolean
}

const useStyles = makeStyles((theme) => ({
  attachmentsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.875rem',
    maxWidth: 200,
  },
  userAttachmentItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  fileIcon: {
    fontSize: '1rem',
    color: theme.palette.text.secondary,
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  extensionLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
    marginLeft: theme.spacing(0.5),
  },
  tooltip: {
    fontSize: '0.85rem',
    padding: '6px 10px',
  },
}))

const getFileExtension = (filename: string): string => {
  const parts = filename.split('.')
  return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : ''
}

const MessageAttachments = ({ attachments, isUserMessage = false }: Props) => {
  const classes = useStyles()

  if (!attachments || attachments.length === 0) {
    return null
  }

  return (
    <div className={classes.attachmentsContainer}>
      {attachments.map((filename, index) => {
        const extension = getFileExtension(filename)
        
        return (
          <Tooltip
            key={index}
            title={filename}
            classes={{ tooltip: classes.tooltip }}
            PopperProps={{
              popperOptions: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, 8],
                    },
                  },
                ],
              },
            }}
          >
            <div
              className={`${classes.attachmentItem} ${
                isUserMessage ? classes.userAttachmentItem : ''
              }`}
            >
              <InsertDriveFileIcon className={classes.fileIcon} />
              <Typography className={classes.fileName} variant="body2">
                {filename}
              </Typography>
              {extension && (
                <Typography className={classes.extensionLabel} variant="caption">
                  {extension}
                </Typography>
              )}
            </div>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default MessageAttachments
